import * as React from 'react';
import { cn } from '@/lib/cn';

type InputProps = React.InputHTMLAttributes<HTMLInputElement> & { ref?: React.Ref<HTMLInputElement> };

export const Input = (props: InputProps) => {
  const { className, type, ref, ...rest } = props;
  return (
    <input
      type={type}
      ref={ref}
      className={cn(
        'flex h-10 w-full rounded-md border border-border-subtle bg-surface px-3 py-2 text-sm text-foreground transition-colors',
        'placeholder:text-text-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/60 focus-visible:border-transparent',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'aria-invalid:border-danger/60 aria-invalid:ring-1 aria-invalid:ring-danger/40',
        className,
      )}
      {...rest}
    />
  );
};
Input.displayName = 'Input';
